import React from "react";
import {Box} from "@mui/material";
import Header from "./Header";
import Viewer from "./Viewer";

const PackageViewer = ({
  categoryPath,
  packageId,
  packageTitle,
  packageMetadata,
  packageAttachments,
  packageApproved
}) => {
  return (
    <Box
      id="package-viewer"
      className="package-viewer"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box
        id="package-viewer__header"
        sx={{
          width: "100%",
          padding: "0 16px"
        }}
      >
        <Header
          categoryPath={categoryPath}
          packageId={packageId}
          packageTitle={packageTitle}
          packageApproved={packageApproved}
          attachments={packageAttachments}
        />
      </Box>
      <Box
        id="package-viewer__viewer"
        sx={{
          width: "100%",
          height: "100%",
          minHeight: "400px",
          padding: "0px 16px 16px"
        }}
      >
        <Viewer packageId={packageId} hasMetadata={packageMetadata} />
      </Box>
    </Box>
  );
};

export default PackageViewer;
